import createReducer from 'utils/createReducer';
import {
  handleWholeAreaAssignment,
  addAssignment,
  removeAssignment,
  removeAllAssignments
} from './utils';

const actionTypes = {
  init: 'init',
  setActiveStepNum: 'setActiveStepNum',
  setFloorInfo: 'setFloorInfo',
  setFloorPlanImage: 'setFloorPlanImage',
  toggleMultipleAreas: 'setMultipleAreas',
  addAreaAssignment: 'addAreaAssignment',
  removeAreaAssignment: 'removeAreaAssignment',
  setWholeAreaAssignmentValues: 'setWholeAreaAssignmentValues',
  setSeatPositions: 'setSeatPositions',
  setFacilityDetails: 'setFacilityDetails'
};

const initialState = {
  activeStepNum: 0,
  floorInfo: {
    country: '',
    city: '',
    building: '',
    floorName: '',
    areaSize: 0,
    maxCapacity: 0
  },
  floorPlanImage: null,
  floorAreas: {
    multipleAreas: true,
    areaAssignments: [],
    wholeAreaAssignment: [{facilityAssignmentTypeValues: []}]
  },
  floorSeats: {
    positions: []
  }
};

const facilitiesReducer = createReducer(initialState, {
  [actionTypes.init]: () => initialState,
  [actionTypes.setActiveStepNum]: (state, payload) => ({
    ...state,
    activeStepNum: payload
  }),
  [actionTypes.setFloorInfo]: (state, payload) => ({
    ...state,
    floorInfo: {
      ...state.floorInfo,
      ...payload
    }
  }),
  [actionTypes.setFloorPlanImage]: (state, payload) => ({
    ...state,
    floorPlanImage: payload
  }),
  [actionTypes.toggleMultipleAreas]: (state) => {
    const {multipleAreas, areaAssignments, wholeAreaAssignment} = state.floorAreas;
    const multipleAreasOpposite = !multipleAreas;

    return {
      ...state,
      floorAreas: {
        ...state.floorAreas,
        multipleAreas: multipleAreasOpposite,
        areaAssignments: removeAllAssignments(!multipleAreasOpposite, areaAssignments),
        wholeAreaAssignment: removeAllAssignments(multipleAreasOpposite, wholeAreaAssignment)
      }
    };
  },
  [actionTypes.addAreaAssignment]: (state, payload) => ({
    ...state,
    floorAreas: {
      ...state.floorAreas,
      areaAssignments: addAssignment(state.floorAreas.areaAssignments, payload)
    }
  }),
  [actionTypes.removeAreaAssignment]: (state, payload) => ({
    ...state,
    floorAreas: {
      ...state.floorAreas,
      areaAssignments: removeAssignment(state.floorAreas.areaAssignments, payload)
    }
  }),
  [actionTypes.setWholeAreaAssignmentValues]: (state, payload) => ({
    ...state,
    floorAreas: {
      ...state.floorAreas,
      wholeAreaAssignment: handleWholeAreaAssignment(state.floorAreas.wholeAreaAssignment, payload)
    }
  }),
  [actionTypes.setSeatPositions]: (state, payload) => ({
    ...state,
    floorSeats: {
      ...state.floorSeats,
      positions: payload
    }
  }),
  [actionTypes.setFacilityDetails]: (state, payload) => ({
    ...state,
    ...payload
  })
});

export {actionTypes, facilitiesReducer, initialState};
